import { Controller } from "@hotwired/stimulus"
import TomSelect  from 'tom-select'

export default class extends Controller {
    static values = {
        options: Object
    }

    connect() {
        const options = Object.assign({}, this._defaultOptions(this.element), this.optionsValue);

        this.choices = new TomSelect(this.element, options)
    }

    _defaultOptions(select) {
        return {}
    }
}